/*  报纸通用排序
    Author:fanglijuan
    Time:2018-01-08
*/
"use strict";
angular.module("productManageMentNewpaperCommOrderModule", [])
    .controller("productManageMentNewpaperCommOrderCtrl", ["$scope", "$modalInstance", "$stateParams", "modalDialog", "trsHttpService", "trsspliceString", "sortInfo",
        function($scope, $modalInstance, $stateParams, modalDialog, trsHttpService, trsspliceString, sortInfo) {
            initStatus();
            initData();

            function initStatus() {
                $scope.sitePosition = [{
                    value: 1,
                    name: "最前"
                }, {
                    value: 2,
                    name: "最后"
                }, {
                    value: 3,
                    name: "指定位置"
                }];
                $scope.list = {
                    value: 1,
                    curPosition: sortInfo.oldPosition, //原位置
                    aimedPosition: "", //自定义排序
                    curItemName: sortInfo.curItemName, //显示名称
                    totalLength: sortInfo.allCounts //总数
                };
                $scope.params = {
                    serviceid: "mlf_websiteconfig",
                    methodname: "recordBaseChannel",
                    Position: "", //新位置
                    ObjType: sortInfo.objType, //栏目/站点类型{站点:103;栏目:101}
                    ObjId: sortInfo.objId //需要排序的栏目/站点ID
                };
            }
            /**
             * [initData description]初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                if(angular.isDefined(sortInfo.params)){//处理例如采编分类列表页排序接口不一致问题
                    $scope.params = sortInfo.params;
                }
            }
            /**
             * [confirm description]确定
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                switch ($scope.list.value) {
                    case 1:
                        $scope.params.Position = 1;
                        save();
                        break;
                    case 2:
                        $scope.params.Position = sortInfo.allCounts;
                        save();
                        break;
                    case 3:
                        if (isNaN($scope.list.aimedPosition - 1) || $scope.list.aimedPosition < 1 || $scope.list.aimedPosition > $scope.list.totalLength || Math.floor($scope.list.aimedPosition) != $scope.list.aimedPosition) {
                            modalDialog.alertType("排序失败", "请输入1到" + $scope.list.totalLength + "之间的正整数", "error", false);
                            return;
                        }
                        $scope.params.Position = $scope.list.aimedPosition;
                        save();
                        break;
                };
            };
            /**
             * [save description]保存
             * @return {[type]} [description]
             */
            function save() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                    modalDialog.alertType("保存成功", "", "success", false);
                    $modalInstance.close(data);
                });
            }
            /**
             * [cancel description]取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);
